import React from 'react';
import { useTranslation } from 'react-i18next';

function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return [];
}

export default function TermsOfService() {
  const { t } = useTranslation();
  const sections = toArray(t('info.termsPage.sections', { returnObjects: true }));

  return (
    <div className="container">
      <h2>{t('info.termsPage.introTitle')}</h2>
      <p>{t('info.termsPage.introParagraph')}</p>

      {sections.map((section, idx) => {
        const paragraphs = toArray(section.paragraphs);
        const subsections = toArray(section.subsections);

        return (
          <section key={`terms-section-${idx}`}>
            <h2>{section.title}</h2>
            {paragraphs.map((paragraph, pIdx) => (
              <p key={`terms-section-${idx}-p-${pIdx}`}>{paragraph}</p>
            ))}

            {subsections.map((subsection, sIdx) => {
              const subParagraphs = toArray(subsection.paragraphs);
              return (
                <div key={`terms-section-${idx}-sub-${sIdx}`}>
                  <h3>{subsection.title}</h3>
                  {subParagraphs.map((paragraph, spIdx) => (
                    <p key={`terms-section-${idx}-sub-${sIdx}-p-${spIdx}`}>
                      {paragraph}
                    </p>
                  ))}
                </div>
              );
            })}
          </section>
        );
      })}

      <p>{t('info.termsPage.effectiveDate')}</p>
    </div>
  );
}
